export default __webpack_public_path__ + "static/media/invisalign.60cef26d.svg";